// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import UserApiKeySchema from './user-api-key-schema';
import ResourceLinkSchema from './resource-link-schema';
import PaginationDataSchema from './pagination-data-schema';

const schema = {
  $id: '/user-api-key-paging-result-schema',
  type: 'object',
  required: [],
  properties: {
    items: {
      type: 'array',
      nullable: true,
      items: { ...UserApiKeySchema },
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    paginationData: {
      ...PaginationDataSchema,
    },
  },
} as IJSONSchema;

export default schema;
